import React from 'react';
import Page from '../components/Page';
import ComingSoonMsg from '../components/ComingSoon';

class CrmPage extends React.Component {
  render() {
    return (
      <Page
        className="page"
        title="CRM"
        breadcrumbs={[{ name: 'CRM', active: true }]}
      >
        <ComingSoonMsg />
      </Page>
    );
  }
}
export default CrmPage;
